import axios from 'axios';
import get from 'lodash/get';

let graphqlURL = `${process.env.VUE_APP_API_URL}/`;
if (window.location.hostname.includes('hihellocoupon')) {
  graphqlURL = graphqlURL.replace('datahoreca', 'hihellocoupon');
}

export function createResponse(response) {
  const data = get(response, 'data.data');
  const errors = response.errors || get(response, 'data.errors') || [];

  if (!data) {
    return {
      errors: errors.length ? errors : ['Something went wrong'],
    };
  }

  // Combine all errors into an array
  errors.push(...Object
    .values(data)
    .flatMap(obj => obj && obj.errors)
    .filter(v => !!v));

  return { errors, data };
}

// convert some error string to graphql-structure error response
export function createErrorResponse(errorMessage) {
  return createResponse({
    errors: [{
      field: null,
      message: errorMessage,
    }],
  });
}

export const getPlainAxios = () => axios.create({
  baseURL: graphqlURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const axiosApiInstance = getPlainAxios();

export default axiosApiInstance;
